<template>
  <article class="performer-member-item">
    <div class="performer-member-item-img">
      <img :src="memberImgUrl" :alt="name" />
    </div>
    <div class="performer-member-item-info">
      <h3 class="performer-member-item-info-name">
        {{ name }}
      </h3>
      <p>
        {{ description }}
      </p>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    memberImgUrl: {
      type: String
    },
    name: {
      type: String
    },
    description: {
      type: String
    },
  }
}
</script>

<style lang="scss" scoped>
  .performer-member-item {
    display: flex;

    &-img {
      margin-right: 20px;

      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
    }
  }
  .performer-member-item-info-name{
    font-size: 14px;
    color: #333;
    text-align: left;
    padding-bottom: 0;
    margin-bottom: 0;
  }
</style>
